import React, { useEffect, useState } from "react";
import Header from './Header.js';
import Stickyheader from './Stickyheader.js';
import "./App.css";
import veg from '../frontend/veg.jpg';
import nonveg from '../frontend/non-veg.png';
import egg from '../frontend/egg.jpg';
import filter from "../frontend/filter.png";
import { useParams } from "react-router";
import search from "../frontend/search.png";
import { Helmet } from "react-helmet";

const Ordermenu = () => {
  const params = useParams();
  const id = 1;//params.id.toString();

  const [activeStates, setActiveStates] = useState(Array(50).fill(false));

  const [scrolltop, setScrolltop] = useState(Array(50).fill(false));

  const [productData, setproductData] = useState([]);
  const [allProductData, setAllProductData] = useState([]);
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    productsData();
  }
    , []);

  const productsData = () => {
    fetch("https://api.novetheitaliankitchen.in/index.php/Api/allProductsdata", {
      method: "POST",
      body: JSON.stringify({
        main_category_id: id,
      }),
      headers: {
        Accept: "application/json",
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result);
        if (result.data != "") {
          setproductData(result.data);
          setAllProductData(result.data.sub_cat);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  // Function to toggle the active state for a specific item
  const toggleAccordion = (index) => {
    setActiveStates(prevStates => {
      const newStates = [...prevStates];
      newStates[index] = !newStates[index];
      return newStates;
    });
  };

  const linkredirect = (index) => {
    setScrolltop(prevStates => {
      const newStates = prevStates.map((state, i) => i === index);
      return newStates;
    });
  }


  const [checkedItems, setCheckedItems] = useState({}); // State to hold checked status of checkboxes

  // Function to handle checkbox change
  const handleCheckboxChange = (event) => {
    const { name, checked, value } = event.target;
    const updatedCheckedItems = { ...checkedItems, [name]: checked ? value : undefined };
    setCheckedItems(updatedCheckedItems);
    //console.log(updatedCheckedItems);
    productsDatabyFilters(updatedCheckedItems);
  };

  let timeoutId;

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchInput(value);
    clearTimeout(timeoutId); // Clear any previously scheduled call
    searchData();
  };

  const searchData = (event) => {
    fetch("https://api.novetheitaliankitchen.in/index.php/Api/searchData", {
      method: "POST",
      body: JSON.stringify(
        {
          search: searchInput,
          main_category_id: id
        }),
      headers: {
        Accept: "application/json",
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result);
        if (result.data != "") {
          setproductData(result.data);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  const productsDatabyFilters = (data) => {
    fetch("https://api.novetheitaliankitchen.in/index.php/Api/productsDataByFilter", {
      method: "POST",
      body: JSON.stringify({ ...data, main_category_id: id }),
      headers: {
        Accept: "application/json",
        "Content-type": "application/json; charset=UTF-8",
      },
    })
      .then((res) => res.json())
      .then((result) => {
        //console.log(result);
        if (result.data != "") {
          setproductData(result.data);
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  }

  const ldJson = {
    "@context": "https://schema.org",
    "@type": "Restaurant",
    "url": "https://novetheitaliankitchen.in/menu",
    "name": "Nove - The Italian Kitchen",
    "description": "More than just Dining. Enjoy pasta making classes, lazy Sunday brunches, weekend breakfast and weekly Hi-tea, celebrity chef takeovers, art and music events ...",
    "servesCuisine": [
      "Italian Fusion"
    ],
    "hasMenu": {
      "@type": "Menu",
      "hasMenuSection": {
        "@type": "MenuSection",
        "name": "Food",
        "description": "More than just Dining. Enjoy pasta making classes, lazy Sunday brunches, weekend breakfast and weekly Hi-tea, celebrity chef takeovers, art and music events ...",
        "image": [
          "https://api.novetheitaliankitchen.in/uploads/logo/original.png",
        ],
        // "offers":{
        //    "@type":"Offer",
        //    "availabilityEnds":"2017-03-02T08:22:00",
        //    "availabilityStarts":"2017-03-02T08:22:00"
        // },
        "hasMenuItem": productData.map((item) => (
          item.sub_cat.map((data) => ({
            "@type": "MenuItem",
            "name": data.name,
            "description": data.description,
            "offers": {
              "@type": "Offer",
              "price": data.current_price,
              "priceCurrency": "INR"
            },
            "nutrition": {
              "@type": "NutritionInformation",
              "calories": "170 calories",
              "fatContent": "3 grams",
              "fiberContent": "2 grams",
              "proteinContent": "4 grams"
            },
            "suitableForDiet": "https://schema.org/GlutenFreeDiet"
          }))
        )),


      },
      "inLanguage": "English"
    }
  }

  const getImageSource = (typeId) => {
    if (typeId === '1') {
      return veg;
    } else if (typeId === '2') {
      return nonveg;
    } else {
      return egg;
    }
  };

  return (
    <>
      <Header />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(ldJson)}
        </script>
      </Helmet>
      <Stickyheader />
      <div className="container-fluid">
        <div className="filter-cont">
          {/* <div className="fiter-main">
          <img src={filter} alt="filter" />
          <span>Filter</span>
        </div> */}
          <div className="fiter-main">
            <label htmlFor="veg" className="container-radio">
              Veg
              <input type="checkbox" name="veg" id="veg" defaultValue="1" checked={checkedItems['veg'] || false} onChange={handleCheckboxChange} />
              <span className="checkmark" />
            </label>
          </div>
          {/* <div className="fiter-main">
          <label htmlFor="Egg" className="container-radio"> 
            Egg
            <input type="checkbox" name="Egg" id="Egg" defaultValue="Egg" />
            <span className="checkmark" />
          </label>
        </div> */}
          <div className="fiter-main">
            <label htmlFor="nonveg" className="container-radio">
              Non-Veg
              <input type="checkbox" name="nonveg" id="nonveg" defaultValue="2" checked={checkedItems['nonveg'] || false} onChange={handleCheckboxChange} />
              <span className="checkmark" />
            </label>
          </div>
          <div className="fiter-main">
            <label htmlFor="egg" className="container-radio">
              Egg
              <input type="checkbox" name="egg" id="egg" defaultValue="3" checked={checkedItems['egg'] || false} onChange={handleCheckboxChange} />
              <span className="checkmark" />
            </label>
          </div>

          <div className="fiter-main">
            <label htmlFor="new" className="container-radio">
              New
              <input type="checkbox" name="new" id="new" defaultValue="NEW" checked={checkedItems['new'] || false} onChange={handleCheckboxChange} />
              <span className="checkmark" />
            </label>
          </div>
          <div className="fiter-main">
            <label htmlFor="Must_Try" className="container-radio">
              Must Try!
              <input type="checkbox" name="Must Try!" id="Must_Try" defaultValue="Must Try!" checked={checkedItems['Must Try!'] || false} onChange={handleCheckboxChange} />
              <span className="checkmark" />
            </label>
          </div>
          {/* <div className="fiter-main">
          <label htmlFor="veg" className="container-radio"> 
            Trending
            <input type="checkbox" name="Trending" id="Trending" defaultValue="Trending" />
            <span className="checkmark" />
          </label>
        </div> */}
        </div>
        <form className="searchform">
          <input className="" type="text" onChange={handleSearch} name="search" />
          <div id="search"><img src={search} /></div>

        </form>

        {productData.map((item, i) => (
          <>
            {item.sub_cat.length > 0 &&
              <section className={`${activeStates[i] ? "active" : ""} ${scrolltop[i] ? "scroll" : ""} menuSection`} id={`section-${i}`} key={i}>
                <div className="container">
                  <div className="strip"
                    onClick={() => toggleAccordion(i)}
                  >
                    <span >{item.category}</span>
                  </div>
                  <div className="d-flex-cards" >
                    {item.sub_cat.map(sub_cat => (

                      <div className="card" key={sub_cat.id}>
                        {/* <a href={"/menu-details/"+sub_cat.name}> */}
                        <a href={"/menu-details/" + encodeURIComponent(sub_cat.name.replace(/ /g, '-')) + '-' + sub_cat.id}>

                          <figure>
                            <div className="img-wrap">
                              <img src={sub_cat.image} />
                            </div>
                            <figcaption>
                              <div className="patch">
                                <span className={sub_cat.product_status ? sub_cat.product_status.toLowerCase() : ""} >{sub_cat.product_status}</span>
                                <img src={getImageSource(sub_cat.type_id)} alt="" />

                              </div>
                              <h3>{sub_cat.name}</h3>

                              <p>
                                {sub_cat.description.split('<br>').map((line, i) => (
                                  <React.Fragment key={i}>
                                    {line}
                                    <br />
                                  </React.Fragment>
                                ))}
                              </p>

                              <span className="cost">&#x20b9; {sub_cat.current_price} </span>
                            </figcaption>
                          </figure>
                        </a>
                      </div>
                    ))}

                  </div>
                </div>
              </section>
            }
          </>
        ))}



        {/* <section className="contact" id="Contact">
          <div className="container">
            <div className="d-flex">
              <div className="equal-cont">
                <span className="subtitle">REGISTER</span>
                <h2>Fill Form</h2>
                <form>
                  <input type="text" name="name" placeholder="Name" />
                  <input type="number" maxLength={10} name="phone" placeholder="Phone" />
                  <input type="email" name="email" placeholder="Email" />
                  <input type="text" name="password" placeholder="Password" />
                  <button type="submit" name="submit">Submit</button>
                </form>
              </div>
              <div className="equal-cont">
                <span className="subtitle">ADDRESS</span>
                <h2>About Us</h2>
                <div className="single-add">
                  <h3>Address</h3>
                  <p>2900 Lapeer Rd, Port Hurons, MI 49070</p>
                </div>
                <div className="single-add">
                  <h3>Phone</h3>
                  <p>8005550855</p>
                  <p>8005550855</p>
                </div>
                <div className="single-add">
                  <h3>Email</h3>
                  <p>info@companyname.com</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

      </div>
      <div className="sticky-menu">
        <ul>
          {productData.map((item, i) => (
            <li className="footer-listitem" onClick={() => linkredirect(i)} key={i}> <a href={'#section-' + i} >{item.category}</a></li>
          ))}
        </ul>
      </div>

    </>
  )
}

export default Ordermenu;